export default __webpack_public_path__ + "static/media/047-fire-sign.fbf42505.png";